import { useEffect, useMemo } from 'react';
import { useThemeCustom } from '../hooks/useThemeCustom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { buildMuiTheme } from '../theme/buildMuiTheme';
import { applyColorModeAttribute, applyThemeCssVars } from '../theme/resolveThemeTokens';
import { ensureHeadingFont } from '../theme/headingFont';

/**
 * Motor único de estilo do painel. Junta as três camadas (docs/ANALISE-TEMAS-MARCA-VS-OPERACAO.md):
 *   - ESCALA OPERACIONAL do modo → vem do tokens.css pelo atributo `data-color-mode` no <html>;
 *   - ACENTO do nicho no modo + fonte de título → CSS vars inline no :root (resolveThemeTokens);
 *   - tema MUI com `palette.mode` real — montado em theme/buildMuiTheme.js, a MESMA função que o
 *     estúdio do pacote do Claude Design usa.
 */
export default function ThemeApplier({ children }) {
  const { themeTokens: t } = useThemeCustom();

  const muiTheme = useMemo(() => buildMuiTheme({ mode: t.mode, vars: { ...t.scale, ...t.cssVars } }), [t]);

  // Modo no <html> (troca a escala do tokens.css) + acento/título inline no :root.
  useEffect(() => {
    applyColorModeAttribute(t.mode);
    applyThemeCssVars(t.cssVars);
    ensureHeadingFont(t.fontHeading);
  }, [t]);

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
}

ThemeApplier.propTypes = {
  children: PropTypes.node.isRequired,
};
